import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import getMonth from './setMonth';
import { toast } from 'react-toastify';

const AddForm = ({
  show,
  toggle,
  fetchTransactions,
  showInfoMonth,
  showInfoCreatedBy,
}) => {
  const [type, setType] = useState('expense');
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');

  const { trackerId, members } = JSON.parse(localStorage.getItem('user'));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      type,
      description: description.trim(),
      amount: amount.trim(),
      trackerId,
      createdBy: members,
    };
    const validationErrors = [];
    if (!body.description) {
      validationErrors.push('Descrierea nu este completata!');
    } else if (!/^[a-zA-Z0-9À-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿ\s]+$/.test(body.description)) {
      validationErrors.push('Descrierea nu este valida!');
    }
    if (!body.amount) {
      validationErrors.push('Suma nu este completata!');
    } else if (!/^[1-9][0-9]+$/.test(body.amount)) {
      validationErrors.push('Suma nu este valida!');
    }
    if (validationErrors.length) {
      toast.error(({ closeToast }) => (
        <>
          {validationErrors.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </>
      ));
      return;
    }
    try {
      const res = await fetch(`https://api.dcsoft.ro/ext/api/transactions`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok)
        throw new Error(`Error adding data: ${res.status} - ${res.statusText}`);
      toast.success('Tranzactia a fost adaugata!');
      fetchTransactions(body.trackerId, 'all', body.createdBy, getMonth());
      showInfoMonth(getMonth());
      showInfoCreatedBy(body.createdBy);
      setType('expense');
      setDescription('');
      setAmount('');
      toggle();
    } catch (error) {
      toast.error('Eroare adaugare tranzactie!');
      console.log(error.message);
    }
  };

  return (
    <form
      className={show ? 'add-form' : 'add-form close'}
      noValidate
      onSubmit={handleSubmit}
    >
      <h3>
        Adauga o tranzactie noua
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="close-icon"
          onClick={() => {
            setType('expense');
            setDescription('');
            setAmount('');
            toggle();
          }}
        />
      </h3>
      <div className="form-control">
        <label>Tip</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="expense">Cheltuieli</option>
          <option value="income">Venituri</option>
        </select>
      </div>
      <div className="form-control">
        <label>Descriere</label>
        <input
          type="text"
          placeholder="Descriere..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <div className="form-control">
        <label>Suma</label>
        <input
          type="text"
          inputMode="numeric"
          placeholder="Suma..."
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>
      <input type="submit" className="btn add-btn" value="Adauga tranzactia" />
    </form>
  );
};

export default AddForm;
